<div class="card-header" [ngClass]="classes" [ngStyle]="styles">
    <ng-content></ng-content>
</div>